










import { Component, Vue, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import { MenuMixins } from './MenuMixins';

@Component
export default class TypeSelector extends mixins(MenuMixins) {
  @Prop({ required: true, type: String, default: '' })
  value: string | undefined;
  @Prop({ required: false, type: Array, default: () => ['html', 'list', 'link', 'vain'] })
  typeList: string[] | undefined;
}
